export default __webpack_public_path__ + "../images/partners-logo-8.png";